import { SafeJSON } from './../../shared/safe-json';
import { Parent } from './../juvenile-case-sections/parent';
import { OtherAllegation } from './../juvenile-case-sections/other-allegations';

export class AllegationResult {
    private json: any;
    private isConclusionOfLaw: false;
    private caseIssueId: string;
    private parents: any = [];
    private attorneys: any = [];
    private otherAllegations: any = [];

    constructor(json: any, caseIssueId: string) {
        this.json = json;
        this.caseIssueId = caseIssueId;
        this.populateParents();
        this.populateAttorneys();
        this.populateOtherAllegations();
    }

    getAdjDate(): string {
        return SafeJSON.get('jaaAdjDate', this.json);
    }

    getAdjEoDate(): string {
        return SafeJSON.get('jaaAdjEoDate', this.json);
    }

    populateAttorneys() {
        let attoerneysArr: any = [];
        let selectedAttorneys: any = SafeJSON.get('selectedAttorneys', this.json);
        let attorneys: any = SafeJSON.get('attorneys', this.json);

        for (const attorneyId of selectedAttorneys) {
            attoerneysArr.push(attorneyId);
        }

        if (attoerneysArr.length > 0) {
            for (const attorneyId of attoerneysArr) {
                for (const attorneyObj of attorneys) {
                    let tempId: string = SafeJSON.get('primaryKey', attorneyObj);
                    if (tempId === attorneyId) {
                        let name: string = SafeJSON.get('attorneyName', attorneyObj);
                        this.attorneys.push(name);
                    }
                }
            }
        }
        this.attorneys.sort();
    }

    populateParents() {
        let obj: any = SafeJSON.get('parents', this.json);
        let index = '0';
        for (const issue of obj) {
            let value = new Parent(issue, index);
            this.parents.push(value);
        }
    }

    populateOtherAllegations() {
        let obj: any = SafeJSON.get('allegations', this.json);
        for (const otherAllegation of obj) {
            let allegationId: string = SafeJSON.get('allegationId', otherAllegation);
            if (allegationId !== this.caseIssueId) {
                let value = new OtherAllegation(otherAllegation);
                this.otherAllegations.push(value);
            }
        }
    }

    getParents(): any[] {
        this.parents.sort(function (parent1, parent2) {
            return parent1.getPartyName() === parent2.getPartyName() ? 0 : parent1.getPartyName() < parent2.getPartyName() ? -1 : 1;
        });
        return this.parents;
    }

    getAttorneys(): any[] {
        return this.attorneys;
    }

    getOtherAllegations(): any[] {
        return this.otherAllegations;
    }

    getAttorneyName(): string {
        return SafeJSON.get('attorneys.attorneyName', this.json);
    }

    getAllegationProvenCode(): string {
        return SafeJSON.get('allegationProvenCode', this.json);
    }

    getAllegationProvenN(): string {
        return SafeJSON.get('allegationProvenN', this.json);
    }

    getAllegationProvenA(): string {
        return SafeJSON.get('allegationProvenA', this.json);
    }

    getAllegationProvenP(): string {
        return SafeJSON.get('allegationProvenP', this.json);
    }

    getFactsFound(): string {
        return SafeJSON.get('factsFound', this.json);
    }

    getLawConclusionCode(): string {
        return SafeJSON.get('lawConclusionCode', this.json);
    }

    getJuvenileOffenseDegreeCode(): string {
        return SafeJSON.get('juvenileOffenseDegreeCode', this.json);
    }

    getOrderCode(): string {
        return SafeJSON.get('orderCode', this.json);
    }

    getTransferCountyName(): string {
        return SafeJSON.get('transferCountyName', this.json);
    }

    getContinueDisposeDate(): string {
        return SafeJSON.get('continueDispositionDate', this.json);
    }

    getUnderFollowingConditionInd(): string {
        return SafeJSON.get('underFollowingConditionInd', this.json);
    }

    getUnderConditions(): string {
        return SafeJSON.get('underConditions', this.json);
    }

    getAlcoholTestInd(): string {
        return SafeJSON.get('alcoholTestInd', this.json);
    }

    getControlledSubstanceTestInd(): string {
        return SafeJSON.get('controlledSubstanceTestInd', this.json);
    }

    getFingerprintPhotographInd(): string {
        return SafeJSON.get('fingerprintPhotographInd', this.json);
    }

    getFingerPrintOfficerName(): string {
        return SafeJSON.get('fingerPrintOfficerName', this.json);
    }

    getOtherCourtOrderInd(): string {
        return SafeJSON.get('otherCourtOrderInd', this.json);
    }

    getOtherOrderText(): string {
        return SafeJSON.get('otherOrderText', this.json);
    }

    /* Adjudication Undisciplined */
    /* getAdjudicationDate(): string {
         return SafeJSON.get('adjudicationDate', this.json);
     }
     getAdjudicationEoDate(): string {
         return SafeJSON.get('adjudicationBean.adjEoDate', this.json);
     }
     getProvenInd(): string {
         return SafeJSON.get('provenInd', this.json);
     }
     getFactsNotes(): string {
         return SafeJSON.get('factsNotes', this.json);
     }
     getCourtJurisdictionInd(): string {
         return SafeJSON.get('courtJurisdictionInd', this.json);
     }
     getOrderedInd(): string {
         return SafeJSON.get('otherOrderText', this.json);
     }
     getTransCounty(): string {
         return SafeJSON.get('transCounty', this.json);
     }
     getContinuedDate(): string {
         return SafeJSON.get('continuedDate', this.json);
     }
     getConditionsInd(): string {
         return SafeJSON.get('conditionsInd', this.json);
     }
     getOrdersNotes(): string {
         return SafeJSON.get('ordersNotes', this.json);
     } */
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/juvenile/juvenile-case-sections/allegation-result.ts